/* PS AFEX S1 Hero — name-on-dial entry flow */
(function () {
  if (window.__PS_AFEX_S1__) return;
  window.__PS_AFEX_S1__ = true;

  function playTick(a, b, c, d) {
    if (window.PS_AFEX && window.PS_AFEX.playTick) window.PS_AFEX.playTick(a, b, c, d);
  }

  function init() {
    var root = document.getElementById('ps-afex-hero');
    if (!root) return;

    /* Particles */
    var particleHost = document.getElementById('ps-afex-heroParticles');
    if (particleHost && !particleHost.childElementCount) {
      for (var i = 0; i < 28; i++) {
        var p = document.createElement('div');
        p.className = 'particle';
        p.style.left = Math.random() * 100 + '%';
        p.style.bottom = '-10px';
        p.style.animationDuration = (6 + Math.random() * 8) + 's';
        p.style.animationDelay = (Math.random() * 8) + 's';
        particleHost.appendChild(p);
      }
    }

    var entryStage = document.getElementById('ps-afex-entryStage');
    var welcomeStage = document.getElementById('ps-afex-welcomeStage');
    var nameInput = document.getElementById('ps-afex-nameInput');
    var dialName = document.getElementById('ps-afex-dialName');
    var nameHint = document.getElementById('ps-afex-nameHint');
    var welcomeHeadline = document.getElementById('ps-afex-welcomeHeadline');
    var beginBtn = document.getElementById('ps-afex-beginBtn');
    var scrollHint = document.getElementById('ps-afex-scrollHint');
    var autoEnterTimer = null;
    var hasEntered = false;

    if (!nameInput || !dialName) return;

    nameInput.addEventListener('input', function () {
      var val = nameInput.value.trim();
      /* textContent only — never innerHTML with user input (XSS) */
      dialName.textContent = '';
      dialName.appendChild(document.createTextNode(val ? val : 'there'));
      var cursor = document.createElement('span');
      cursor.className = 'dial-cursor';
      dialName.appendChild(cursor);
      dialName.classList.remove('pulse');
      void dialName.offsetWidth;
      dialName.classList.add('pulse');
      playTick(300 + Math.random() * 120, 0.03, 'sine', 0.02);

      clearTimeout(autoEnterTimer);
      if (val.length >= 2) {
        nameHint.textContent = '';
        nameHint.appendChild(document.createTextNode('Entering as '));
        var bold = document.createElement('b');
        bold.textContent = val;
        nameHint.appendChild(bold);
        nameHint.appendChild(document.createTextNode('…'));
        autoEnterTimer = setTimeout(enterExperience, 1200);
      } else {
        nameHint.textContent = "Just start typing — we'll take it from there.";
      }
    });

    nameInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && nameInput.value.trim().length > 0) {
        clearTimeout(autoEnterTimer);
        enterExperience();
      }
    });

    function enterExperience() {
      if (hasEntered) return;
      hasEntered = true;
      var userName = nameInput.value.trim() || 'Guest';
      if (window.PS_AFEX && window.PS_AFEX.setUserName) {
        window.PS_AFEX.setUserName(userName);
      } else {
        window.PS_AFEX = window.PS_AFEX || {};
        window.PS_AFEX.userName = userName;
      }
      playTick(520, 0.12, 'triangle', 0.06);
      entryStage.style.transition = 'opacity .6s ease, transform .6s ease';
      entryStage.style.opacity = '0';
      entryStage.style.transform = 'scale(.96)';
      setTimeout(function () {
        entryStage.style.display = 'none';
        welcomeStage.style.display = 'block';
        welcomeHeadline.textContent = 'Welcome, ' + userName + '.';
        welcomeStage.style.opacity = '0';
        welcomeStage.style.transform = 'scale(1.04)';
        requestAnimationFrame(function () {
          welcomeStage.style.transition = 'opacity .8s ease, transform .8s ease';
          welcomeStage.style.opacity = '1';
          welcomeStage.style.transform = 'scale(1)';
        });
      }, 600);
    }

    if (beginBtn) {
      beginBtn.addEventListener('click', function () {
        playTick(380, 0.1, 'sine', 0.05);
        if (scrollHint) scrollHint.style.display = 'flex';
        if (window.PS_AFEX && window.PS_AFEX.showNav) window.PS_AFEX.showNav();
        var ai = document.getElementById('ps-afex-aicook');
        if (ai) ai.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
